// @flow

import { createAction } from 'redux-actions';

import type { Thunk } from 'types/redux';
import updateStateAddressWs from 'api/xws/profile/stateAddressWs';

// Action Types
import { SET_STATES_DATA } from './actionTypes';

// Selectors
import { getWebkey } from 'store/reducers/queryParams/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';
import { getAddressCountryCode } from 'store/reducers/appointment/contactInfo/address/selectors';

const setStatesAddress = createAction(SET_STATES_DATA);

export const setStatesData = (statesData: Array<Object>) => {
  return {
    type: SET_STATES_DATA,
    payload: statesData
  };
};

export const getCountryStates = (
  countryCode: string
): Thunk<Promise<any>> => async (dispatch, getState) => {
  const webkey = getWebkey(getState());
  const tokenId = getTokenId(getState());
  const locale = getLocaleCode(getState());
  const countryCodeParam =
    countryCode || getAddressCountryCode(getState()) || '';

  try {
    const { data } = await updateStateAddressWs({
      tokenId,
      webkey,
      locale,
      countryCodeParam
    });
    dispatch(setStatesAddress(data.states));
    return data;
  } catch (e) {
    /* eslint-disable no-console */
    console.log(e);
    /* eslint-enable no-console */
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/states/actions.js